// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K1jDekQpj8xeOtu__Pem{background:var(--yellow-40);color:var(--content-primary-tertiary)}.GiVtu22nfk9iYm_vt6vA{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlighter": `K1jDekQpj8xeOtu__Pem`,
	"highlighter--label": `GiVtu22nfk9iYm_vt6vA`,
	"highlighterLabel": `GiVtu22nfk9iYm_vt6vA`
};
export default ___CSS_LOADER_EXPORT___;
